// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-bulletin-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 90vh;
    padding: 20px;
    background: rgba(0, 0, 0, 0.2); /* Slight transparency */
  }
  
  .news-bulletin {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    width: 80%;
    max-width: 700px;
    text-align: center;
  }
  
  .date-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  }
  
  .date-table th, .date-table td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
  }
  
  .clickable-date {
    font-weight: bold;
    color: #007bff;
    transition: 0.3s;
  }
  
  .clickable-date:hover {
    color: #0056b3;
  }
  
  .download-btn {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .download-btn:hover {
    background-color: #218838;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/newsBulletin.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,8BAA8B,EAAE,wBAAwB;EAC1D;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".news-bulletin-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 90vh;\r\n    padding: 20px;\r\n    background: rgba(0, 0, 0, 0.2); /* Slight transparency */\r\n  }\r\n  \r\n  .news-bulletin {\r\n    background-color: white;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n    width: 80%;\r\n    max-width: 700px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .date-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .date-table th, .date-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 12px;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .clickable-date {\r\n    font-weight: bold;\r\n    color: #007bff;\r\n    transition: 0.3s;\r\n  }\r\n  \r\n  .clickable-date:hover {\r\n    color: #0056b3;\r\n  }\r\n  \r\n  .download-btn {\r\n    background-color: #28a745;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 12px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: 0.3s;\r\n  }\r\n  \r\n  .download-btn:hover {\r\n    background-color: #218838;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
